const ANCILLARY_PROVIDED_FLAG = {
    NotProvided: '0',
    FreeOfCharge: '1',
    Billed: '2'
};

type ANCILLARY_PROVIDED_FLAG = typeof ANCILLARY_PROVIDED_FLAG;

export default ANCILLARY_PROVIDED_FLAG;